<template>
  <div class="position ask">
    <a-modal
      class="ask"
      :visible="visible"
      v-bind="$attrs"
      v-on="$listeners"
      :closable="false"
      :maskClosable="false"
      :footer="null"
    >
      <div class="modal_header p-20">
        <h4>
          <span class="modal_title">提问</span>
        </h4>
        <img @click="close" :src="closeImg" alt="" />
        <!-- <a-icon type="close" @click="close" /> -->
      </div>
      <div class="p-20"><a-input v-model="form.content" type="textarea" :rows="6" class="ask-textarea" /></div>
      <div class="ask-bask">
        <div @click="goShowImage()">
          <img src="../img/img-icon.png" class="icon-play" v-if="!isImage && !form.photos" />
          <img src="../img/img-active.png" class="icon-play" v-else />
        </div>
        <div><a-button :loading="loading" class="btn_right" type="primary" @click="submit">提交 </a-button></div>
      </div>
    </a-modal>
    <div class="ask-upload" v-if="isImage">
      <div class="upload_header">
        <div>
          <span class="upload_title">图片上传</span>
          <span class="upload-num">{{ form.photos && form.photos.length ? form.photos.length : '0' }}/6</span>
        </div>
        <img @click="isImage = false" :src="closeImg" alt="" />
        <!-- <a-icon type="close" @click="close" /> -->
      </div>
      <div class="picture-up">
        <upload
          listType="picture-card"
          path="img/ask/"
          @uploadChange="uploadChange"
          :limitNum="limitNum"
          :fileList="coverFileList"
        ></upload>
      </div>
    </div>
  </div>
</template>
<script>
import zModal from '@/components/ZModal'
import upload from '@/components/Upload'
// import { addTheme } from '@/api/myQa'
import closeImg from '@/assets/icons/close.png'
export default {
  name: '',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // loading: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data() {
    return {
      loading: false,
      isImage: false,
      limitNum: 6,
      closeImg,
      studentData: {},
      form: {
        content: '',
        photos: '',
      },
    }
  },
  watch: {
    visible(val) {
      if (val) {
        document.querySelector('body').setAttribute('style', 'overflow: auto')
      } else {
        this.form.content = ''
        this.form.photos = ''
       }
    },
  },
  components: {
    zModal,
    upload,
  },
  computed: {
    coverFileList() {
      let arr = []
      if (this.form.photos) {
        arr = this.form.photos
      }
      return arr
    },
  },
  methods: {
    close() {
      this.$emit('close')
      this.isImage = false
      this.$emit('update:visible', false)
    },
    uploadChange(ev) {
      this.form.photos = ev
      console.log('this.form.photos', this.form.photos, ev)
    },
    goShowImage() {
      this.isImage = !this.isImage
    },
    async submit() {
      if (this.$route.query) {
        this.studentData = this.$route.query
      }
      if (!this.form.content) {
        this.$message.error({
          title: '错误',
          content: '请填写内容！',
        })
        return false
      }
      const params = {
        content: this.form.content,
        photos: this.form.photos ? this.form.photos.join(',') : '',
        classesId: this.studentData.classesId,
        planclassesId: this.studentData.planclassesId ? this.studentData.planclassesId : '',
      }
      await this.$http.post(`/b/classes/theme/v2/addTheme`, params)
      this.$message.success('提交成功')
      this.close()
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .ant-modal-content {
  border-radius: 15px;
}
/deep/.ant-modal-body {
  padding: 0;
}
.p-12 {
  padding: 12px;
}
.border {
  border-top: 1px solid #ced3dc;
  border-bottom: 1px solid #ced3dc;
}
.modal_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // margin: -24px;
  // padding: 12px;
  // padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
  .modal_title {
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    position: absolute;
    top: 15px;
    left: 48%;
  }
  img {
    width: 12px;
    height: 12px;
    cursor: pointer;
  }
}
.upload_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // margin: -24px;
  // padding: 12px;
  // padding-bottom: 12px;
  .upload_title {
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    color: #333;
  }
  img {
    width: 12px;
    height: 12px;
    cursor: pointer;
  }
}
.ant-form {
  margin-top: 16px;
  .ant-input {
    background: #f5f6fa;
    border-radius: 15px;
    border: none;
  }
}
.p-20 {
  padding: 20px;
}
.ask-textarea {
  background: #f5f6fa;
  border-radius: 15px;
  border: none;
}
.ask-bask {
  padding: 0 20px 20px;
  display: flex;
  justify-content: space-between;
}
.ask-upload {
  background: #fff;
  padding: 20px;
  width: 320px;
  position: fixed;
  top: 360px;
  left: 34%;
  z-index: 99;
}
.position {
  // position: relative;
}
.picture-up {
  margin-top: 10px;
}
.upload-num {
  font-size: 12px;
  color: #8b8d90;
  margin-left: 10px;
}
</style>
<style>
.picture-up .ant-upload.ant-upload-select-picture-card {
  width: 80px;
  height: 80px;
}
.picture-up .ant-upload.ant-upload-select-picture-card {
  width: 80px;
  height: 80px;
}
.picture-up .ant-upload-list-picture-card .ant-upload-list-item {
  width: 80px;
  height: 80px;
}
.picture-up .ant-upload-list-picture-card-container {
  width: 80px;
  height: 80px;
}
.icon-play {
  width: 20px;
  height: 20px;
}
</style>
<style>
.ask .ant-modal-mask {
  z-index: 10;
}
.ask .ant-modal-wrap {
  z-index: 10;
}
</style>
